export default {
	getAllAccountData(state) {
		return state.accountData;
	},
  getAccountOwnerName(state){
    return `${state.user.firstName} ${state.user.lastName}`;
  }
};
